import { getSessionAuthentication, baseUrl } from '../common/Api';

interface FetchOptions {
    method: string;
    headers: Record<string, string>;
    body?: string;
}

function getHeaders(): Record<string, string> {
    const auth = getSessionAuthentication();
    return {
        'Content-Type': 'application/json',
        'Authorization': auth.token,
        'x-cleverapps-tenant': auth.tenantStringIdentifier,
    };
}

async function legacyFetch<T>(path: string, options?: Partial<FetchOptions>): Promise<T> {
    const response = await fetch(baseUrl + path, {
        method: options?.method ?? 'GET',
        headers: getHeaders(),
        body: options?.body,
    });
    if (!response.ok) {
        const text = await response.text();
        let message = `API error: ${response.status} ${response.statusText}`;
        try {
            const parsed = JSON.parse(text);
            if (parsed?.message) message = parsed.message;
        } catch { /* ignore */ }
        throw new Error(message);
    }
    const text = await response.text();
    return text ? JSON.parse(text) : null;
}

export interface PriceInterval {
    minValue: number;
    maxValue: number;
    resultValue: number;
}

export interface PsychologicalPrice {
    id: number;
    name: string;
    description?: string;
    priceIntervals: PriceInterval[];
}

export async function getPsychologicalPrice(id: number): Promise<PsychologicalPrice> {
    return legacyFetch<PsychologicalPrice>(`psychologicalprices/${id}`);
}

export async function createPsychologicalPrice(p: Partial<PsychologicalPrice>): Promise<PsychologicalPrice> {
    return legacyFetch<PsychologicalPrice>('psychologicalprices', {
        method: 'POST',
        body: JSON.stringify(p),
    });
}

export async function updatePsychologicalPrice(p: PsychologicalPrice): Promise<PsychologicalPrice> {
    return legacyFetch<PsychologicalPrice>(`psychologicalprices/${p.id}`, {
        method: 'PUT',
        body: JSON.stringify(p),
    });
}
